

import React, { useState, useEffect } from 'react';

export default function OtherAssetsModal({
  isOpen,
  onClose,
  caseId,
  item,
  onSave,
  exemptions = [],
  scope,
}) {
  const [description, setDescription] = useState('');
  const [amount, setAmount] = useState('');
  const [exemptionCode, setExemptionCode] = useState('');
  const [exemptionAmount, setExemptionAmount] = useState('');
  const API_URL = process.env.REACT_APP_API_URL;
  const TOKEN = localStorage.getItem('accessToken');

  useEffect(() => {
    if (item) {
      setDescription(item.description || '');
      setAmount(item.amount || '');
      setExemptionCode(item.exemption_code || '');
      setExemptionAmount(item.exemption_amount || '');
    } else {
      setDescription('');
      setAmount('');
      setExemptionCode(scope === 'TN' ? '26-2-103' : '');
      setExemptionAmount('');
    }
  }, [item, scope]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      description,
      amount,
      exemption_code: exemptionCode,
      exemption_amount: exemptionAmount,
    };
    const url = item
      ? `${API_URL}/case/${caseId}/other-properties/${item.id}/edit/`
      : `${API_URL}/case/${caseId}/other-properties/add/`;
    const method = item ? 'PUT' : 'POST';
    const response = await fetch(url, {
      method,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TOKEN}`,
      },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      alert('Error saving item.');
      return;
    }
    const saved = await response.json();
    onSave(saved);
    onClose();
  };

  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-lg p-6">
        <h3 className="text-lg font-semibold mb-4">
          {item ? 'Edit Other Property' : 'Add Other Property'}
        </h3>
        <form onSubmit={handleSubmit} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {/* Description */}
          <div className="col-span-2">
            <label className="block text-sm font-medium text-gray-700">Description</label>
            <textarea
              rows={3}
              value={description}
              onChange={e => setDescription(e.target.value)}
              required
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
            />
          </div>
          {/* Amount */}
          <div>
            <label className="block text-sm font-medium text-gray-700">Amount</label>
            <input
              type="number"
              step="0.01"
              value={amount}
              onChange={e => setAmount(e.target.value)}
              required
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
            />
          </div>
          {/* Exemption Amount */}
          <div>
            <label className="block text-sm font-medium text-gray-700">Exemption Amount</label>
            <input
              type="number"
              step="0.01"
              value={exemptionAmount}
              onChange={e => setExemptionAmount(e.target.value)}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
            />
          </div>
          {/* Exemption Code */}
          <div className="col-span-2">
            <label className="block text-sm font-medium text-gray-700">Exemption Code</label>
            <select
              value={exemptionCode}
              onChange={e => setExemptionCode(e.target.value)}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
            >
              <option value="">None</option>
              {exemptions.map(ex => (
                <option key={ex.law} value={ex.law}>
                  {ex.asset_name} — {ex.law}
                </option>
              ))}
            </select>
          </div>
          {/* Buttons */}
          <div className="flex justify-end space-x-2 pt-4 col-span-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}